import { useState, useEffect } from 'react';
import { throttle } from '../utils';

/**
 * 滚动监听Hook，用于导航高亮和滚动动画
 * @param elementIds 要监听的元素ID数组
 * @param offset 偏移量
 * @returns 当前激活的元素ID
 */
export const useScrollSpy = (elementIds: string[], offset: number = 100): string => {
  const [activeId, setActiveId] = useState<string>('');

  useEffect(() => {
    const handleScroll = throttle(() => {
      const scrollPosition = window.scrollY + offset;
      
      // 找到当前滚动位置对应的元素
      for (let i = elementIds.length - 1; i >= 0; i--) {
        const element = document.getElementById(elementIds[i]);
        if (element) {
          const elementTop = element.offsetTop;
          if (scrollPosition >= elementTop) {
            setActiveId(elementIds[i]);
            break;
          }
        }
      }
    }, 100);

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // 初始调用

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [elementIds, offset]);

  return activeId;
};